/**
 * Capability checks against the permission list the session returns.
 *
 * The frontend guards on capabilities rather than role names: asking for
 * canAccess('payroll') means adding a role later never requires editing a
 * route, while checking for ['Admin', 'Contador'] would mean editing every
 * one of them.
 *
 * These are convenience only. The backend enforces the same rules and is the
 * guarantee; hiding a button protects nothing on its own.
 *
 * See docs/backend/roles_permissions.md for the matrix these read.
 */

/** Exact match against a backend permission string, e.g. 'quotes.manage_quotes'. */
export const hasPermission = (permissions, permission) =>
  Array.isArray(permissions) && permissions.includes(permission);

/**
 * Can the module be read?
 *
 * The module name is both the Django app label and the codename suffix, so
 * 'clients' becomes 'clients.access_clients'. Keeping that convention in one
 * place means a rename on the backend breaks one function, not fifty call
 * sites.
 */
export const canAccess = (permissions, module) =>
  hasPermission(permissions, `${module}.access_${module}`);

/** Can the module be created in, edited or deleted from? */
export const canManage = (permissions, module) =>
  hasPermission(permissions, `${module}.manage_${module}`);
